import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Modal, ModalBody } from 'reactstrap';
import Avatar from '../../assets/images/profil.png';
import { updateMe } from '../../actions/ProfilAction';
import Profile from '../../assets/images/logo/profile.svg';
import info from '../../../package.json';

const avatarStyle = {
  padding: 2.5,
  marginBottom: 25,
  width: 130,
  height: 130,
  borderRadius: '50%',
  border: '2.5px solid #86005b',
};

class ProfileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      modal: false,
      error: false,
      showinput: false,
      confirmpass: true,
      file: null,
      password: '',
    };
    this.toggle = this.toggle.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleImageErrored = this.handleImageErrored.bind(this);
  }

  toggle() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => this.props.ToggleModal()
    );
  }

  togglePassword() {
    this.setState({
      showinput: true,
    });
  }

  updateProfile() {
    this.setState({ isLoading: true });
    this.props.updateMe(
      this.props.token,
      document.getElementById('firstName').value,
      document.getElementById('lastName').value,
      document.getElementById('email').value,
      document.getElementById('phone').value,
      null,
      this.state.file,
      () => {
        this.setState({ isLoading: false });
        this.props.ToggleModal();
      },
      () => this.setState({ isLoading: false })
    );
  }

  handleChange(e) {
    document.getElementById('avatar-preview').src = URL.createObjectURL(e.target.files[0]);
    this.setState({
      file: e.target.files[0],
    });
  }

  handleImageErrored() {
    this.setState({ file: Avatar });
  }

  render() {
    const data = this.props.profil ? this.props.profil : this.props.user;
    const email =
      data.local && data.local.email ? data.local.email : data.facebook && data.facebook.email ? data.facebook.email : null;

    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.toggle}
        className="txt-white pt-x"
        external={
          <button className="close" style={{ position: 'absolute', top: 25, right: 25, color: 'white' }}>
            <span className="fas fa-times" />
          </button>
        }
      >
        <ModalBody>
          <div className="row mb-5">
            <label htmlFor="avatar-input" className="col-4 offset-4">
              <img
                id="avatar-preview"
                style={avatarStyle}
                src={data.image || Avatar}
                onError={this.handleImageErrored}
                alt="avatar"
              />
              <input
                disabled={this.state.isLoading}
                id="avatar-input"
                type="file"
                onChange={e => this.handleChange(e)}
                style={{ display: 'none' }}
              />
            </label>
            <div className="col-12 mb-3 row">
              <img className="col-2" src={Profile} style={{ height: 20, marginTop: 15 }} />
              <input
                id="firstName"
                defaultValue={data.firstName}
                className="input-login col-5"
                placeholder="Nom"
                type="text"
                name="firstName"
                disabled={this.state.isLoading}
              />
              <input
                id="lastName"
                defaultValue={data.lastName}
                className="input-login col-4 offset-1"
                placeholder="Prènom"
                type="text"
                name="lastName"
                disabled={this.state.isLoading}
              />
            </div>
            <div className="col-12 mb-3 row">
              <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                <span className="far fa-envelope-open" />
              </span>
              <input
                id="email"
                type="email"
                name="email"
                defaultValue={email || ''}
                className="input-login col-10"
                placeholder="E-mail"
                disabled={this.state.isLoading || email}
              />
            </div>
            <div className="col-12 mb-3 row">
              <span className="col-2" style={{ height: 20, marginTop: 15 }}>
                <span className="fas fa-phone" />
              </span>
              <input
                id="phone"
                type="tel"
                name="phone"
                defaultValue={data.phone}
                className="input-login col-10"
                placeholder="Numéro du téléphone"
              />
            </div>
          </div>
          <div className="col-12 row ">
            <div className="col-2" />
            <button disabled={this.state.isLoading} type="reset" className="btn-custom btn-silver col-4" onClick={this.toggle}>
              Annuler
            </button>
            <div className="col-2" />
            <button disabled={this.state.isLoading} className="btn-custom btn-purple col-4" onClick={this.updateProfile}>
              Mise á jour
            </button>
          </div>
          <br />
          <div className="row" hidden={!this.state.error}>
            <Alert color="danger" className="offset-2 col-8">
              La mise á jour de votre profile est echouée.
            </Alert>
          </div>
          <div style={{ marginTop: 50, textAlign: 'center' }}>
            <p style={{ flexDirection: 'row', justifyContent: 'space-evenly' }}>
              <a style={{ color: 'white' }} href={`/data-settings`}>
                Paramètres de données
              </a>
              <br />
              <a style={{ color: 'white' }} href={`/privacy-policy`}>
                Politique de confidentialité
              </a>
              <span style={{ color: 'white', marginRight: 25, marginLeft: 25 }}>-</span>
              <a style={{ color: 'white' }} href={`/terms-conditions`}>
                Termes et conditions
              </a>
            </p>
            <p style={{ color: 'white', textAlign: 'center', fontSize: 10, opacity: 0.75 }}>
              © Copyright {new Date().getFullYear()} Golf Advanced Service - Tous Droits Réservés.
              <br />
              Version: {info.version}
              <br />
              <a style={{ color: 'white', textAlign: 'center', fontSize: 10, opacity: 0.75 }} href={'https://tuskens.com'}>
                Technologies by Tuskens ®
              </a>
            </p>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default connect(
  store => ({
    user: store.login.user,
    token: store.login.token,
    profil: store.profil,
  }),
  { updateMe }
)(ProfileModal);



// WEBPACK FOOTER //
// ./src/components/Modals/ProfileModal.js